import React from "react";
import { Card } from "@mui/material";
import { classList } from "utils";

const SimpleCard = ({ children, title, subtitle, icon, className }) => {
  return (
    <div className={className}>
      <Card
        elevation={6}
        className="px-6 py-5 h-full tw-rounded-lg"
        sx={{
          borderRadius: 5,
        }}
      >
        {title && (
          <div
            className={classList({
              "card-title": true,
              "mb-4": !subtitle,
            })}
          >
            {title}
          </div>
        )}
        {subtitle && <div className="card-subtitle mb-4">{subtitle}</div>}
        {children}
      </Card>
    </div>
  );
};

export default SimpleCard;
